import React from 'react';
import { Clock, FileWarning, BrainCircuit, History } from 'lucide-react';
import { SlideLayout } from '../SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProspectProblemSlide(props: SlideProps) {
  return <SlideLayout {...props} title="The Assessment Burden" subtitle="We know that creating high-quality assessments is one of the most time-consuming parts of your job." data-id="element-295">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-8 items-center" data-id="element-296">
        <div className="space-y-6" data-id="element-297">
          <div className="flex gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-indigo-200 transition-colors" data-id="element-298">
            <div className="p-3 bg-red-100 text-red-600 rounded-xl h-fit" data-id="element-299">
              <Clock className="w-6 h-6" data-id="element-300" />
            </div>
            <div data-id="element-301">
              <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-302">
                Endless Hours
              </h3>
              <p className="text-slate-600" data-id="element-303">
                Watching videos, reading PDFs, and transcribing content to find
                suitable questions takes weeks.
              </p>
            </div>
          </div>

          <div className="flex gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-indigo-200 transition-colors" data-id="element-304">
            <div className="p-3 bg-orange-100 text-orange-600 rounded-xl h-fit" data-id="element-305">
              <FileWarning className="w-6 h-6" data-id="element-306" />
            </div>
            <div data-id="element-307">
              <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-308">
                Formatting Headaches
              </h3>
              <p className="text-slate-600" data-id="element-309">
                Aligning text, fixing images, and ensuring brand consistency
                across every paper is tedious.
              </p>
            </div>
          </div>

          <div className="flex gap-4 p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-indigo-200 transition-colors" data-id="element-310">
            <div className="p-3 bg-blue-100 text-blue-600 rounded-xl h-fit" data-id="element-311">
              <BrainCircuit className="w-6 h-6" data-id="element-312" />
            </div>
            <div data-id="element-313">
              <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-314">
                Cognitive Overload
              </h3>
              <p className="text-slate-600" data-id="element-315">
                Balancing question difficulty and variety manually is mentally
                exhausting.
              </p>
            </div>
          </div>
        </div>

        {/* Visual Timeline */}
        <div className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm" data-id="element-316">
          <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-317">
            <History className="w-5 h-5 text-slate-400" data-id="element-318" />
            Typical Workflow
          </h3>

          <div className="space-y-8 relative pl-8 border-l-2 border-slate-100" data-id="element-319">
            <div className="relative" data-id="element-320">
              <div className="absolute -left-[41px] w-6 h-6 rounded-full bg-slate-200 border-4 border-white" data-id="element-321"></div>
              <div className="text-sm font-bold text-slate-400 mb-1" data-id="element-322">
                WEEK 1-2
              </div>
              <div className="font-bold text-slate-800" data-id="element-323">
                Content Review & Sourcing
              </div>
              <div className="text-sm text-slate-500" data-id="element-324">
                Watching lectures, reading chapters
              </div>
            </div>
            <div className="relative" data-id="element-325">
              <div className="absolute -left-[41px] w-6 h-6 rounded-full bg-slate-200 border-4 border-white" data-id="element-326"></div>
              <div className="text-sm font-bold text-slate-400 mb-1" data-id="element-327">
                WEEK 3
              </div>
              <div className="font-bold text-slate-800" data-id="element-328">Drafting Questions</div>
              <div className="text-sm text-slate-500" data-id="element-329">
                Writing, reviewing, checking answers
              </div>
            </div>
            <div className="relative" data-id="element-330">
              <div className="absolute -left-[41px] w-6 h-6 rounded-full bg-slate-200 border-4 border-white" data-id="element-331"></div>
              <div className="text-sm font-bold text-slate-400 mb-1" data-id="element-332">
                WEEK 4
              </div>
              <div className="font-bold text-slate-800" data-id="element-333">
                Formatting & Layout
              </div>
              <div className="text-sm text-slate-500" data-id="element-334">
                Word/LaTeX struggles, branding
              </div>
            </div>
            <div className="relative" data-id="element-335">
              <div className="absolute -left-[41px] w-6 h-6 rounded-full bg-red-500 border-4 border-white animate-pulse" data-id="element-336"></div>
              <div className="text-sm font-bold text-red-500 mb-1" data-id="element-337">WEEK 5</div>
              <div className="font-bold text-slate-800" data-id="element-338">
                Final Review & Print
              </div>
              <div className="text-sm text-slate-500" data-id="element-339">
                Last minute corrections
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}